import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { Button } from '../button/button';
import { useContentModal } from '../content-modal/content-modal';
import { useYouTubeModal } from '../youtube-modal/youtube-modal';
import './styles.scss';
import { Icon } from '../icon/icon';
import cx from 'classnames';

export const EventBlock = ({
  image,
  date,
  title,
  text,
  link = null,
  imageLink = null,
  videoLink = null,
  children = null,
  className = undefined,
}) => {
  const { t } = useI18next();
  const modal = useContentModal();
  const youtubeModal = useYouTubeModal();

  const handleOpenImage = () => {
    modal.open(
      <img
        loading="lazy"
        alt={title}
        className="w-100"
        src={imageLink?.includes('/') ? imageLink : `/img/campaigns/${imageLink}.webp`}
      />,
    );
  };

  const handleOpenVideo = () => {
    youtubeModal.open(videoLink);
  };

  return (
    <div className={cx('event-block mb-5', className)}>
      <img src={`/img/campaigns/${image}.webp`} loading="lazy" alt={title} className="w-100 mb-2" />
      <small className="event-block__date">{date}</small>

      {link && (
        <a href={link} rel="noreferrer nofollow" target="_blank">
          <h3 className="mt-2 mb-4 fw-semibold h5 event-block__heading">{title} </h3>
        </a>
      )}

      {!link && <h3 className="mt-2 mb-4 fw-semibold h5 text-success event-block__heading">{title} </h3>}

      <p className="mb-5 event-block__content">{text}</p>
      <div className="event-block__actions mb-5">
        {link && (
          <a href={link} rel="noreferrer nofollow" target="_blank">
            <Button title={t('g.learn-more')} className={'text-uppercase shadow btn-success'} />
          </a>
        )}
        {imageLink && (
          <Button title={t('g.learn-more')} className={'text-uppercase shadow btn-success'} onClick={handleOpenImage} />
        )}
        {videoLink && (
          <Button
            title={t('g.video')}
            icon={<Icon name={'play-fill'} size={19} />}
            className="text-uppercase shadow btn-success"
            onClick={handleOpenVideo}
          />
        )}
        {children}
      </div>
    </div>
  );
};
